import ModuleConfig from './Config';

const actions = ModuleConfig.Actions;

const initialState = {
    events: [],
    event: null,
    loading: false,
    error: null,
    count: 0
}

export default function calendar(state = initialState, action) {
    switch (action.type) {
        case actions.getAll.request.id:
        case actions.getOne.request.id:
        case actions.create.request.id:
        case actions.edit.request.id:
        case actions.delete.request.id:
            return {
                ...state,
                loading: true,
                error: null
            };

        case actions.getAll.success.id:
            return {
                ...state,
                events: action.options.data,
                count: action.options.count || action.options.data.length,
                loading: false,
                error: null
            };

        case actions.getOne.success.id:
            return {
                ...state,
                event: action.options,
                loading: false,
                error: null
            };

        case actions.create.success.id:
            return {
                ...state,
                events: [...state.events, action.options],
                loading: false,
                error: null
            };

        case actions.edit.success.id:
            return {
                ...state,
                events: state.events.map(event => 
                    event.id === action.options.id ? action.options : event
                ),
                event: action.options,
                loading: false,
                error: null
            };

        case actions.delete.success.id:
            return {
                ...state,
                events: state.events.filter(event => event.id !== action.options.id),
                loading: false,
                error: null,
                eventToDelete: null
            };

        case actions.getAll.failure.id:
        case actions.getOne.failure.id:
        case actions.create.failure.id:
        case actions.edit.failure.id:
        case actions.delete.failure.id:
            return {
                ...state,
                loading: false,
                error: action.options.error
            };

        default:
            return state;
    }
}
